"use client";

import * as React from "react";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    question: "Comment Stack Flow se connecte-t-il à mes instances N8N ?",
    answer:
      "Stack Flow se connecte à vos instances N8N via une clé API que vous générez depuis votre interface N8N. La connexion est sécurisée, testée automatiquement lors de l'ajout, et permet à l'IA de surveiller vos workflows en temps réel sans accéder à vos données sensibles.",
  },
  {
    question: "L'IA peut-elle modifier mes workflows automatiquement ?",
    answer:
      "Non, jamais sans votre validation. L'IA analyse vos workflows, détecte les erreurs et propose des corrections, mais toute modification nécessite votre approbation explicite. Vous gardez le contrôle total sur vos automatisations.",
  },
  {
    question: "Que se passe-t-il quand mes crédits IA sont épuisés ?",
    answer:
      "Une fois vos crédits mensuels épuisés, vous pouvez continuer à surveiller vos instances et workflows, mais les fonctionnalités d'analyse IA (AutoFix, génération de rapports, AI Chat) seront désactivées jusqu'au renouvellement. Vous pouvez aussi acheter des crédits supplémentaires à tout moment.",
  },
  {
    question: "Puis-je essayer Stack Flow gratuitement ?",
    answer:
      "Oui ! Le plan Free vous permet de tester gratuitement avec 3 crédits AI Chat, 1 instance N8N et 3 workflows surveillés. C'est idéal pour découvrir la plateforme avant de passer à un plan payant.",
  },
  {
    question: "Comment fonctionne la surveillance en temps réel ?",
    answer:
      "Stack Flow surveille en continu l'état de vos instances (disponibilité, charge serveur) et vos workflows (exécutions, échecs, durée). L'IA lit automatiquement les logs, identifie les erreurs récurrentes et vous envoie des alertes intelligentes pour que vous puissiez réagir rapidement.",
  },
] as const;

const FAQ_SCHEMA_JSON = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: { "@type": "Answer", text: faq.answer },
  })),
});

export function FAQSection() {
  return (
    <section className="relative overflow-hidden bg-black pt-16 pb-16 lg:pt-[120px] lg:pb-[120px]">
      {/* FAQ Schema (JSON-LD) */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: FAQ_SCHEMA_JSON }}
      />

      <div className="relative z-10 mx-auto w-full max-w-[1512px] px-4 sm:px-6 lg:px-8">
        {/* Badge */}
        <div className="mb-8 flex justify-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-5 py-2.5 backdrop-blur-sm">
            <span className="text-[20px]" aria-hidden="true">
              ✨
            </span>
            <span className="font-display text-[16px] font-medium text-white">
              Stack Flow
            </span>
          </div>
        </div>

        {/* Title */}
        <h2 className="mb-16 text-center font-display text-[clamp(28px,3.5vw,48px)] font-bold leading-[1.2] tracking-[-0.02em] text-white">
          Foire Aux
          <br />
          <span className="bg-linear-to-br from-white/40 to-white/20 bg-clip-text text-transparent">
            Questions
          </span>
        </h2>

        {/* Accordion */}
        <div className="mx-auto max-w-[900px]">
          <Accordion type="single" collapsible className="space-y-4">
            {FAQS.map((faq) => (
              <AccordionItem
                key={faq.question}
                value={faq.question}
                className="overflow-hidden rounded-2xl border border-white/10 bg-linear-to-br from-white/5 to-white/2 backdrop-blur-xl"
              >
                <AccordionTrigger className="px-6 py-6 text-left font-display text-[18px] font-semibold text-white hover:no-underline cursor-pointer">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6 font-[Switzer,sans-serif] text-[15px] leading-[1.7] text-white/70">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
